import axios from "axios";
import store from "@/store";

const API_BASE = "/api";

async function authorize(provider: string, authCode: string, redirectUri: string): Promise<string> {
  const params = new URLSearchParams({
    code: authCode,
    // eslint-disable-next-line @typescript-eslint/camelcase
    redirect_uri: redirectUri
  });
  const response = await axios.post(
    `${API_BASE}/authorize/${provider}`, //TODO
    params
  );
  if (response.status == 200) {
    return response.data;
  } else {
    // eslint-disable-next-line no-console
    console.error("authentication failed");
    return "";
  }
}

// Set up a single global interceptor for auth
let interceptorSetup = false;

function ensureAuthInterceptor() {
  if (interceptorSetup) return;
  interceptorSetup = true;

  axios.interceptors.request.use(async config => {
    // Skip auth header for authorize requests
    if (config.url?.startsWith(`${API_BASE}/authorize`)) {
      return config;
    }

    const jwt = store.getters["authentication/jwt"];
    const isExpired = store.getters["authentication/isExpired"];

    // If jwt is set but expired: reauthenticate
    if (jwt && isExpired) {
      config.headers.Authorization = await store.dispatch("authentication/handleLogin");
    } else if (jwt) {
      config.headers.Authorization = jwt;
    }

    return config;
  });
}

// decorator for use in front of service functions that need login
export function useAuth(target: object, propertyKey: string, descriptor: PropertyDescriptor): PropertyDescriptor {
  const originalMethod = descriptor.value;

  descriptor.value = async function(...args: []) {
    ensureAuthInterceptor();
    return originalMethod.apply(this, args);
  };

  return descriptor;
}

export const authService = {
  authorize,
  useAuth
};

export default authService;
